import Repository from "./RepositoryFactoryMain";
const ADD_ATTRIBUTES = "create";
const ADD_ATTRIBUTES_VALUE = "addValue";
const Edit_ATTRIBUTES_VALUE = "editValue";
const GET_ATTRIBUTES = "get";
const GET_SINGLE_ATTRIBUTES = "getSingle";

export default {
  addAttributes(payload) {
    return Repository.post(transformRoute(ADD_ATTRIBUTES), payload);
  },
  addAttributesValue(payload) {
    return Repository.post(transformRoute(ADD_ATTRIBUTES_VALUE), payload);
  },
  editAttributesValue(payload) {
    return Repository.post(transformRoute(Edit_ATTRIBUTES_VALUE), payload);
  },
  getAttributes() {
    return Repository.post(transformRoute(GET_ATTRIBUTES));
  },
  getSingleAttributes(payload) {
    return Repository.post(transformRoute(GET_SINGLE_ATTRIBUTES), payload);
  },
};

const transformRoute = (route) => {
  return `/ecom/attributes/${route}`;
};
